import type { FamilyDeletion } from '../shared/types';

/** Deleting a member or the family can be undone for this many days (server: _shared/accountDeletion.ts). */
export const RESTORE_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

export function familyDeletionFrom(requestedAt: string, familyName: string): FamilyDeletion {
  return {
    family_name: familyName,
    requested_at: requestedAt,
    permanent_at: new Date(new Date(requestedAt).getTime() + RESTORE_DAYS * DAY_MS).toISOString(),
  };
}

/** When something deleted right now would be gone for good (shown in the confirm dialogs). */
export function permanentDateFromNow(now: Date = new Date()): string {
  return new Date(now.getTime() + RESTORE_DAYS * DAY_MS).toISOString();
}

/** Whole days left before a deletion becomes permanent (0 on the last day). */
export function daysLeft(permanentAt: string, now: Date = new Date()): number {
  return Math.max(0, Math.floor((new Date(permanentAt).getTime() - now.getTime()) / DAY_MS));
}

/** "12 November 2026" in the app language. */
export function formatDeletionDate(iso: string, language: string): string {
  try {
    return new Date(iso).toLocaleDateString(language, { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return new Date(iso).toDateString();
  }
}

/** The family name typed to confirm deleting the family (case and outer spaces don't matter). */
export function familyNameMatches(typed: string, familyName: string): boolean {
  const t = typed.trim().toLowerCase();
  return t !== '' && t === familyName.trim().toLowerCase();
}
